import { Box, Typography } from "@material-ui/core";
import React from "react";
import { defineMessages, type MessageDescriptor, useIntl } from "react-intl";
import Diagnosis, { type InpatientDiagnosis } from "./diagnosis";

export interface DiagnosisListProps {
  diagnosisList?: readonly InpatientDiagnosis[];
  title: MessageDescriptor;
}

export const DIAGNOSIS_TITLES = defineMessages({
  admission: {
    id: "inpatient.diagnosis.title.admission",
    defaultMessage: "Admission Diagnosis",
  },
  discharge: {
    id: "inpatient.diagnosis.title.discharge",
    defaultMessage: "Discharge Diagnosis",
  },
});

const DiagnosisList = (props: DiagnosisListProps): React.ReactElement => {
  const { diagnosisList, title } = props;
  const { formatMessage } = useIntl();

  return (
    <Box>
      <Typography variant="body2" color="textSecondary">
        {formatMessage(title)}
      </Typography>
      {diagnosisList?.map((diagnosis, index: number) => {
        return (
          // Index is okay for key as we don't change order and do not have a suitable key in the data

          <Typography variant="body1" gutterBottom key={index}>
            <strong>
              <Diagnosis diagnosis={diagnosis} />
            </strong>
          </Typography>
        );
      })}
    </Box>
  );
};

DiagnosisList.defaultProps = {
  diagnosisList: [],
};

export default DiagnosisList;
